/**
 * PV 號查詢輸入。§7.4「單片查詢：加 PV 號掃碼查詢」。
 *
 * 與 `ScanInput` 不同：那個是「回掃驗證」（比對是否等於預期的號碼），
 * 這個是「查詢」（不知道要查什麼，所以沒有預期值）。兩件事不要混用。
 *
 * 檢查碼用 Mod-11 先驗一次（§14.2 #3 的決議），打錯字當場看得出來，
 * 不必等後端回「找不到」。但**不阻擋送出**——舊標籤可能格式不同，
 * 讓人查得到比讓人卡住重要。
 */

import { useState } from 'react'
import { verifyId } from '../../../shared/lib/checkdigit.js'
import { Button, Field, TextInput } from './ui.js'

export function PanelLookup({ onSubmit, label = 'PV 號', placeholder }: {
  onSubmit: (id: string) => void
  label?: string
  placeholder?: string
}) {
  const [value, setValue] = useState('')
  const trimmed = value.trim()
  const looksValid = trimmed === '' || verifyId(trimmed)

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); if (trimmed) onSubmit(trimmed) }}
      className="flex items-end gap-2"
    >
      <Field
        label={label}
        className="flex-1"
        hint={!looksValid ? '檢查碼對不上——可能是打錯字。仍然可以送出查詢。' : undefined}
      >
        <TextInput
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder ?? 'PVR-01-2634-000481-7'}
          autoFocus
          autoComplete="off"
          spellCheck={false}
          className={`font-mono ${looksValid ? '' : 'border-amber-400 bg-amber-50'}`}
        />
      </Field>
      <Button type="submit" variant="primary" size="lg" disabled={!trimmed} className="mb-[2px]">
        查詢
      </Button>
    </form>
  )
}
